import { useTranslations } from 'next-intl';
import cx from 'classnames';
import CommonIcon from '@/components/CommonIcon';
import Styles from './index.module.scss';
import { isValidDomain } from '@/utils/url';

export interface ILinkPreview {
  className?: string;
  id: string;
  link: string;
  title?: string;
  isEdit?: boolean;
  onRemove: (key: string) => void;
}

const LinkPreview = ({
  className = '',
  id,
  link,
  title,
  isEdit,
  onRemove,
}: ILinkPreview) => {
  const t = useTranslations();

  const handleRemove = () => {
    onRemove(id);
  };

  return (
    <div className={cx(Styles.root, className)}>
      {
        isEdit && <div className={Styles.removeIcon} onClick={handleRemove} />
      }
      {!isEdit && <div className={Styles.title}>{title}</div>}
      <div className={Styles.linkWrapper}>
        {isEdit
          ? (
            <div className={Styles.linkContent}>
              <CommonIcon className={Styles.icon} icon="link" />
              <div className={Styles.text}>
                <p className={Styles.link}>{link}</p>
                <div className={Styles.linkTip}>{t('tips_link_preview')}</div>
              </div>
            </div>
          )
          :
          (() => {
            // 处理链接安全性
            let safeLink = link;
            // 检查是否是有效域名
            if (!isValidDomain(safeLink)) {
              return
            }
            
            return (
              <iframe
                scrolling="no"
                title={title}
                width="100%"
                height="100%"
                frameBorder="0"
                allowFullScreen
                src={safeLink}
              />
            );
          })()}
      </div>
    </div>
  );
};

export default LinkPreview;
